import SvgAnimationBallTriangle from 'components/svgs/animation/ball-triangle';
import React from 'react';
import style from './style.module.scss';

type LoaderTriangleType = {
    loading: boolean;
    width?: number;
    color?: string;
    text?: string;
}

const LoaderTriangle = ({color = "#00c483", loading, text, width = 64 }: LoaderTriangleType) => {
    if (!loading) {
        return <></>
    }
    
    return (
        <div className={style.cLoaderTriangle} >
            <SvgAnimationBallTriangle stroke={color} width={width} />
            {text && (<p className={style.cLoaderTriangle__text}>{text}</p>)}
        </div>
    )
}

export default LoaderTriangle